import { LocalRole } from "@core/model/local-role.enum";

export const appConfig = {
  assetPath: `https://storage.googleapis.com/bukolabs_public/${process.env.REACT_APP_CLIENT}`,
  publicAssetPath: `https://storage.googleapis.com/bukolabs_public/buko-public-assets`,
  client: `${process.env.REACT_APP_CLIENT}`,
  apiUrl: `https://${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_API_URL}`,
  // apiUrl: `http://localhost:3004`,
  dateFormat: "yyyy-MMMM-dd",
  dateTimeFormat: "yyyy-MM-dd p",
  staleTime: 20000, // 20 minutes
  minTimeForRenew: 250, // minimum time passed for the app to renew token
  maxTimeForTimeout: -180, // 3min - max time passed for the app to kick out user
  allowedBusinessRoles: [LocalRole.Admin, LocalRole.Manager, LocalRole.Cashier],
  allowedCustomerRoles: [LocalRole.CardOwner],
};
